<template>
  <div id="map-controls-sidebar-plot">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activePlotSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="mb-1 aisea-text-18-700-white">プロット</span>
            <div class="aisea-text-12-400-white">自社のプロット一覧を表示</div>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_PLOT_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>

        <div class="px-6 mt-4">
          <vs-row vs-type="flex" vs-justify="center" vs-align="center">
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start" vs-align="center">
              <span class="aisea-text-14-400-white">プロットを登録する</span>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end" vs-align="center">
              <plot-select/>
            </vs-col>
          </vs-row>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>

        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pt-4 pb-6"
          :settings="settings"
        >
          <ul>
            <li
              class="pb-2 pl-4 pr-4"
              v-for="plot in plots" :key="plot.id">
              <plot-item :plot="plot"
                         @showDetails="showVesselDetail($event)"
                         @jumpTo="jumpToMap($event)"/>
            </li>
          </ul>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {mapGetters} from "vuex";

import {createNamespacedHelpers} from "vuex";

// Mixins
import {ColorMixin} from "@/mixins";

const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");

import PlotSelect from "@/views/enterprise/management/plot/select/PlotSelect"
import PlotItem from "./PlotItem"

export default {
  name: "Plot",
  mixins: [ColorMixin],
  components: {
    VuePerfectScrollbar,
    PlotSelect,
    PlotItem
  },
  data() {
    return {
      active: false,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
    };
  },
  watch: {},
  computed: {
    ...mapStateOfLiveMap({
      activePlotSidebar: state => state.activePlotSidebar
    }),
    ...mapGetters({
      plots: "enterprisePlot/getPlots",
    }),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  mounted() {
    this.searchPlots(0);
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_PLOT_SIDEBAR",
    ]),
    ...mapActionsOfLiveMap([
      "jumpToMap",
      "showVesselDetail"
    ]),
    searchPlots(page) {

      let request = {
        start: page,
        limit: 99999
      };
      this.$store
        .dispatch("enterprisePlot/fetchPlots", request)
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-plot {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
  }
  .scroll-area--customizer {
    height: calc(100% - 10rem);
  }
  .vs-button-primary.vs-button-filled {
    background-color: $aisea-blue !important;
  }
}

</style>
